var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider",style:({ marginLeft: _vm.mx, marginRight: _vm.mx, marginTop: _vm.my, marginBottom: _vm.my })})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e04d454","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/shared/components/ui/p-horizontal-divider.vue
// module id = 1420
// module chunks = 9 11 12 13 14 16 19 20 23 24 25 28 30 31 32 33 34 35 37 40 42 43 49 56 62 78